import AbstractChannel from './AbstractChannel'

export default class NetPark extends AbstractChannel {

  name = 'netpark'
  title = 'netPark'
  titleShort = 'netPark'
  color = '#2CA02C'

  supportedFeatures = ['blackouts']

}
